/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const SEARCH_FOR_ROUTER_URL = `${API_URL}/account/searchaccount`;
